import React, { useState } from 'react';

import {
  Form,
  FormItem,
  SubmitButton,
  Button,
  Input,
} from '../../../../../components';
import {
  validateChunkOverlapSize,
  validateChunkSize,
} from '../../utils/validator';

export type FormProps = {
  chunkSize: number;
  chunkOverlap: number;
};
type VectorizeFormProps = {
  saving: boolean;
  onCancel: () => void;
  onSave: (data: any) => void;
  isEditMode?: boolean;
};

const VectorizeSourceForm: React.FC<VectorizeFormProps> = ({
  saving,
  onSave,
  onCancel,
  isEditMode = false,
}) => {
  const [values, setValues] = useState<FormProps>({
    chunkSize: 2500,
    chunkOverlap: 250,
  });

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={setValues} initialValue={values}>
        <FormItem<FormProps>
          required
          name="chunkSize"
          label={'Chunk Size'}
          inline={false}
          validate={validateChunkSize}
        >
          <Input />
        </FormItem>
        <FormItem<FormProps>
          required
          name="chunkOverlap"
          label={'Chunk Overlap'}
          inline={false}
          validate={validateChunkOverlapSize}
        >
          <Input />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="medium"
            disabled={saving}
            className="w-full"
            label="Activate"
            loading={saving}
            onClick={() =>
              onSave({
                chunkSize: values.chunkSize,
                chunkOverlap: values.chunkOverlap,
              })
            }
          />
          <Button
            size="medium"
            type="contrast"
            label="Cancel"
            className="w-full text-main"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};

export default VectorizeSourceForm;
